var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.4857 6.76432C18.4037 6.75259 18.3216 6.75259 18.2395 6.76432C16.4224 6.7057 14.9805 5.21684 14.9805 3.38802C14.9805 1.52402 16.4928 0 18.3685 0C20.2325 0 21.7565 1.5123 21.7565 3.38802C21.7448 5.21684 20.3028 6.7057 18.4857 6.76432Z",
    fill: "#9D9DAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.3076 14.8879C20.9945 15.7672 19.154 16.0954 17.4541 15.8727C17.8996 14.9114 18.1341 13.8446 18.1458 12.7192C18.1458 11.5468 17.8879 10.4331 17.3955 9.4601C19.1305 9.22563 20.9711 9.55387 22.2958 10.4331C24.1481 11.6523 24.1481 13.657 22.3076 14.8879Z",
    fill: "#9D9DAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.48563 6.76432C5.56769 6.75259 5.64976 6.75259 5.73182 6.76432C7.54892 6.7057 8.99088 5.21684 8.99088 3.38802C8.99088 1.52402 7.47858 0 5.60286 0C3.73887 0 2.21484 1.5123 2.21484 3.38802C2.22657 5.21684 3.66852 6.7057 5.48563 6.76432Z",
    fill: "#9D9DAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.61338 12.7194C5.61338 13.8565 5.85956 14.9351 6.30505 15.9081C4.65207 16.084 2.92875 15.7323 1.66264 14.8999C-0.189631 13.669 -0.189631 11.6643 1.66264 10.4333C2.91703 9.58926 4.68724 9.2493 6.35194 9.43687C5.87129 10.4216 5.61338 11.5353 5.61338 12.7194Z",
    fill: "#9D9DAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1452 16.2599C12.0514 16.2482 11.9459 16.2482 11.8404 16.2599C9.68328 16.1896 7.95996 14.4194 7.95996 12.2389C7.95996 10.0114 9.75362 8.20605 11.9928 8.20605C14.2202 8.20605 16.0256 10.0114 16.0256 12.2389C16.0256 14.4194 14.314 16.1896 12.1452 16.2599Z",
    fill: "#9D9DAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33449 18.6869C6.56428 19.871 6.56428 21.817 8.33449 22.9893C10.3509 24.3375 13.6568 24.3375 15.6732 22.9893C17.4435 21.8053 17.4435 19.8592 15.6732 18.6869C13.6686 17.3387 10.3626 17.3387 8.33449 18.6869Z",
    fill: "#9D9DAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.1df83f061004e82d3a7469874c72a18f.svg";
export { ForwardRef as ReactComponent };